module.exports = __webpack_public_path__ + "img/about2.6df593c6.svg";